import React, { Suspense, lazy } from "react";
import { DA_PageNotFound } from "@danishagro/shared/src/components/organisms/PageNotFound/PageNotFound.component";
import { usePageLocationContext } from "@contexts/PageLocationContext";
import DA_HomePage from "./Home.page";

const DA_PlaceholderPage = lazy(
    () => import(/* webpackChunkName: "PlaceholderPageChunk" */ "./Placeholder.page")
);

/**
 * Preview-only route component.
 * Reads the page alias from PageLocationContext (which in preview mode is fed by
 * PreviewPageLocationProvider with normalised globalThis.pageContent data) and
 * dispatches to the correct page component.
 */
const DA_PreviewPage = () => {
    const { pageData } = usePageLocationContext();

    if (!pageData) return <DA_PageNotFound code={404} />;

    const alias = pageData.alias || pageData.pageAlias;

    switch (alias) {
        case "frontpage":
            return <DA_HomePage />;
        case "page":
        default:
            return (
                <Suspense fallback={<div className="page-container" />}>
                    <DA_PlaceholderPage />
                </Suspense>
            );
    }
};

export default DA_PreviewPage;
